import {
    createStore, applyMiddleware, compose 
} from 'redux';
import saga, { END } from 'redux-saga';
// const sagaMonitor = require('@redux-saga/simple-saga-monitor');
import rootReducer from './root-reducer';

const createSagaMiddleware = saga;

export default function configureStore(initialState) {

    let composeEnhancers = compose;

    // If Redux Dev Tools Extension is installed, enable it
    if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {

        if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {

            composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
        
        }
    
    }

    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [sagaMiddleware];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const enhancers = [middlewareEnhancer];
    const composedEnhancers = composeEnhancers(...enhancers);

    const store = createStore(rootReducer, initialState, composedEnhancers);

    store.runSaga = sagaMiddleware.run;
    store.close = () => store.dispatch(END);

    return store;

}
